import CityPageToldos from "../components/CityPageToldos";

export default function ToldosBenalmadena() {
  return (
    <CityPageToldos
      name="Benalmádena"
      slug="benalmadena"
      cp="29630, 29631, 29639"
      poblacion={78787}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5988}
      lng={-4.516}
      zonas={["Benalmádena Costa", "Arroyo de la Miel", "Torrequebrada", "Benalmádena Pueblo"]}
      landmarks={["Puerto Marina", "Castillo de Bil-Bil", "Stupa de Iluminación"]}
      municipiosLimitrofes={["Torremolinos", "Mijas", "Alhaurín de la Torre"]}
      festivalLocal="Virgen del Carmen, 16 de julio"
      contextoTipologico="Comunidades extensas en Arroyo de la Miel demandando toldos uniformes según normativa, áticos premium en la Costa con vista al mar, restaurantes Puerto Marina."
      isCoreZone={true}
    />
  );
}